var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification is-warning is-radiusless is-marginless"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t('application_outdated.warning')))]),_vm._v(" "+_vm._s(_vm.$t('application_outdated.suggestion')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }